<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import rem from '@/utils/rem'

export default {
  name: 'app',
  mixins: [rem],
  components: {}
}
</script>
<style>
  .el-dialog__header {
    padding: 0 !important;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
  .el-radio {
    font-size: 16px;
    margin-right: 10px !important;
    color: #00DFFF !important;
  }
  .el-radio__inner {
    font-size: 16rem;
    border: 1px solid #00DFFF !important;
    background-color:transparent  !important;
  }
  .el-radio__input.is-checked+.el-radio__label {
    color:#00DFFF !important;
  }
</style>
